import { Box, Link, Typography } from '@mui/material';
import CLA_LOGO from '../../assets/cla-logo-white.svg';
import { useGetVersionInfoQuery } from '../../redux/api/version.api';
import { ThemeTokens } from '../../utilities/theme';
import { VERSION_INFO } from '../../utilities/env';

const DEFAULT_UNKNOWN_VERSION = 'unknown';

export function Footer() {
  const uiVersion = VERSION_INFO.uiVersion || DEFAULT_UNKNOWN_VERSION;
  const productVersion = VERSION_INFO.productVersion || DEFAULT_UNKNOWN_VERSION;

  // fetch api and db versions using call
  const { data } = useGetVersionInfoQuery();
  const backendVersion = {
    apiVersion: data?.apiVersion ?? DEFAULT_UNKNOWN_VERSION,
    databaseVersion: data?.databaseVersion ?? DEFAULT_UNKNOWN_VERSION,
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: ThemeTokens.colors.primary.main,
        color: ThemeTokens.colors.primary.contrastText,
        pt: 3,
        pb: 2,
        px: 2,
        mt: 'auto',
        minHeight: '6vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          maxWidth: '1480px',
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1.25,
          }}
        >
          <Box component="img" src={CLA_LOGO} alt="CLA Logo" sx={{ height: 40 }} />

          <Link
            href="https://www.claconnect.com/en"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            color="inherit"
            sx={{ '&:hover': { textDecoration: 'underline' } }}
          >
            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
              {new Date().getFullYear()} CliftonLarsonAllen LLP | CLAConnect.com
            </Typography>
          </Link>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontSize: '0.9rem',
            textAlign: { xs: 'left', md: 'right' },
            textUnderlineOffset: '3px',
          }}
        >
          {`Product ${productVersion} / UI ${uiVersion} / API ${backendVersion.apiVersion} / DB ${backendVersion.databaseVersion}`}
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
